import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--tabs"
export default class extends Controller {
  static targets = ["tab", "panel", "select"]
  static values = { active: String, style: { type: String, default: "default" } }

  static STYLE_CLASSES = {
    default: {
      tab: {
        active: ["border-primary-500", "text-primary-600"],
        inactive: ["border-transparent", "text-gray-500", "hover:border-gray-200", "hover:text-gray-700"]
      },
      badge: {
        active: ["bg-primary-100", "text-primary-600"],
        inactive: ["bg-gray-200", "text-gray-900"]
      }
    },
    pills: {
      tab: {
        active: ["bg-primary-100", "text-primary-700"],
        inactive: ["text-gray-600", "hover:bg-gray-100", "hover:text-gray-700"]
      },
      badge: {
        active: ["bg-white", "text-primary-700"],
        inactive: ["bg-gray-200", "text-gray-900"]
      }
    }
  }

  connect() {
    // Set initial active tab
    if (this.activeValue) {
      this.showTab(this.activeValue)
    } else if (this.tabTargets.length > 0) {
      const firstTab = this.tabTargets[0].dataset.tabName
      this.showTab(firstTab)
    }
  }

  select(event) {
    const tabName = event.currentTarget.dataset.tabName
    this.showTab(tabName)
  }

  selectFromDropdown(event) {
    this.showTab(event.target.value)
  }

  showTab(name) {
    this.activeValue = name

    const styles = this.constructor.STYLE_CLASSES[this.styleValue] || this.constructor.STYLE_CLASSES.default

    // Update tabs
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabName === name
      this._applyClasses(tab, styles.tab, isActive)
      tab.setAttribute("aria-selected", isActive)

      // Update badge styling
      const badge = tab.querySelector("[data-tab-badge]")
      if (badge) {
        this._applyClasses(badge, styles.badge, isActive)
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tabName === name
      panel.classList.toggle("hidden", !isActive)
    })

    // Update mobile select
    if (this.hasSelectTarget) {
      this.selectTarget.value = name
    }
  }

  _applyClasses(element, classes, isActive) {
    classes.active.forEach(c => element.classList.toggle(c, isActive))
    classes.inactive.forEach(c => element.classList.toggle(c, !isActive))
  }
}
